import { forwardRef } from "react";
import classnames from "classnames";
import buttonStyles from "@/styles/Button.module.scss";
import VersatileLink from "@/components/VersatileLink";

const ButtonLink = forwardRef((props, ref) => {
  const {
    className,
    fillColor,
    fillMainColor,
    fillGray,
    fillLightGray,
    fillCautionColor,
    fillTransparentGray,
    borderBlue,
    borderGray,
    borderLight,
    borderCaution,
    fontFixed,
    fontFixedLineHeight,
    fontBold,
    large,
    medium,
    small,
    largeFont,
    favBtn,
    favBtnWithLabel,
    listRow,
    scale,
    inline,
    transparent,
    atagProps = {},
    disabled,
    ..._props
  } = props;
  return (
    <VersatileLink
      {..._props}
      className={classnames(buttonStyles.btn, className, {
        [buttonStyles.fillColor]: fillColor,
        [buttonStyles.fillMainColor]: fillMainColor,
        [buttonStyles.fillGray]: fillGray,
        [buttonStyles.fillLightGray]: fillLightGray,
        [buttonStyles.fillCautionColor]: fillCautionColor,
        [buttonStyles.fillTransparentGray]: fillTransparentGray,
        [buttonStyles.borderBlue]: borderBlue,
        [buttonStyles.borderGray]: borderGray,
        [buttonStyles.borderLight]: borderLight,
        [buttonStyles.borderCaution]: borderCaution,
        [buttonStyles.fontFixed]: fontFixed,
        [buttonStyles.fontFixedLineHeight]: fontFixedLineHeight,
        [buttonStyles.fontBold]: fontBold,
        [buttonStyles.large]: large,
        [buttonStyles.medium]: medium,
        [buttonStyles.small]: small,
        [buttonStyles.largeFont]: largeFont,
        [buttonStyles.favBtn]: favBtn,
        [buttonStyles.favBtnWithLabel]: favBtnWithLabel,
        [buttonStyles.listRow]: listRow,
        [buttonStyles.scale]: scale,
        [buttonStyles.inline]: inline,
        [buttonStyles.transparent]: transparent,
        [buttonStyles.disabled]: disabled,
      })}
      role="button"
    >
      {props.children}
    </VersatileLink>
  );
});
ButtonLink.displayName = "ButtonLink";
export default ButtonLink;
